/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { columnsPropType } from '../types';
import { convertUTCtoIST, sequenceStatusFormat } from 'src/constants/utils';
import {
	dateFieldHeader,
	sequenceStatus,
	tooltipFieldHeader,
} from 'src/constants/constVariables';

import styles from './TableRow.module.scss';
import { isPlainObject } from '@reduxjs/toolkit';
import { Tooltip } from '@mui/material';

export const TableRow = ({
	classNames,
	columns,
	index,
	row,
	style,
	snapshot,
	handlePopoverOpen,
	handlePopoverClose,
	rowClick,
	onClickPath,
	onClick,
	selectedRows,
	searchText,
}) => {
	const getFlexAlignment = (alignment) => {
		if (alignment === 'center') return 'center';
		if (alignment === 'right') return 'flex-end';
		return 'flex-start';
	};
	const handleRowClick = () => {
		if (rowClick) rowClick(row);
	};

	const rowDataCommonDiv = (row, col) => {
		return row[col.field] && row[col.field] !== ''
			? Array.isArray(row[col.field])
				? Array.isArray(row[col.field])
					? row[col.field].length > 0
						? row[col.field].join(', ')
						: '-'
					: dateFieldHeader.includes(col.field)
						? convertUTCtoIST(row[col.field])
						: sequenceStatus.includes(col.field)
							? isPlainObject(row[col.field])
								? row[col.field]
								: sequenceStatusFormat(row[col.field])
							: row[col.field]
				: dateFieldHeader.includes(col.field)
					? convertUTCtoIST(row[col.field])
					: sequenceStatus.includes(col.field)
						? isPlainObject(row[col.field])
							? row[col.field]
							: sequenceStatusFormat(row[col.field])
						: row[col.field]
			: '-';
	};

	return (
		<div
			className={clsx(
				styles.tableRow,
				row.isSelected && styles.defaultSelectedRow,
				row?.is_migrated_data && styles.highlightedColor,
				classNames.tableRowClassName instanceof Function
					? classNames.tableRowClassName(row, snapshot?.isDragging)
					: classNames.tableRowClassName
			)}
			style={{
				...style,
			}}
			onClick={handleRowClick}
		>
			{columns.map((col) => {
				const renderColumnCell = () =>
					col.render && row ? (
						col.render(row, index + 1, {
							openEllipsisPopupForEventWithText: handlePopoverOpen,
							closeEllipsisPopup: handlePopoverClose,
						})
					) : onClickPath &&
					  !row?.is_migrated_data &&
					  row?.approval_status?.props?.rowData?.approval_status !==
							'draft' ? (
						<Link
							state={{
								data: row ? JSON.stringify(row) : null,
								search: searchText,
							}}
							to={onClickPath}
						>
							{tooltipFieldHeader.includes(col.field) ? (
								<Tooltip
									title={
										<div className={styles.tooltipText}>
											{rowDataCommonDiv(row, col)}
										</div>
									}
									placement="bottom-start"
									arrow
								>
									<div
										title={
											Array.isArray(row[col.field])
												? row[col.field].join(', ')
												: null
										}
										className={styles.ellipsisText}
										style={{ textAlign: col.alignment || 'left' }}
									>
										{rowDataCommonDiv(row, col)}
									</div>
								</Tooltip>
							) : (
								<div
									title={
										Array.isArray(row[col.field])
											? row[col.field].join(', ')
											: null
									}
									className={styles.ellipsisText}
									style={{ textAlign: col.alignment || 'left' }}
								>
									{rowDataCommonDiv(row, col)}
								</div>
							)}
						</Link>
					) : (
						<>
							{tooltipFieldHeader.includes(col.field) ? (
								<Tooltip
									title={
										<div className={styles.tooltipText}>
											{rowDataCommonDiv(row, col)}
										</div>
									}
									placement="bottom-start"
									arrow
								>
									<div
										title={
											Array.isArray(row[col.field])
												? row[col.field].join(', ')
												: null
										}
										className={styles.ellipsisText}
										style={{ textAlign: col.alignment || 'left' }}
									>
										{rowDataCommonDiv(row, col)}
									</div>
								</Tooltip>
							) : (
								<div
									title={
										Array.isArray(row[col.field])
											? row[col.field].join(', ')
											: null
									}
									className={styles.ellipsisText}
									style={{ textAlign: col.alignment || 'left' }}
								>
									{rowDataCommonDiv(row, col)}
								</div>
							)}
						</>
					);

				return (
					<div
						className={clsx(styles.tableCell, classNames.tableCellClassName)}
						style={{
							height: '100%',
							...col.style,
							...col.cellStyles,
							display: 'inline-flex',
							alignItems: 'center',
							width: col.width,
							justifyContent: getFlexAlignment(col.alignment),
						}}
						key={`${uuidv4()}`}
					>
						{renderColumnCell()}
					</div>
				);
			})}
		</div>
	);
};

TableRow.propTypes = {
	classNames: PropTypes.shape({
		tableContainerClassName: PropTypes.string,
		tableClassName: PropTypes.string,
		tableRowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
		tableHeadClassName: PropTypes.string,
		tableCellClassName: PropTypes.string,
	}),
	columns: columnsPropType,
	index: PropTypes.number,
	row: PropTypes.shape({
		asn: PropTypes.string,
		isSelected: PropTypes.bool,
	}).isRequired,
	style: PropTypes.object,
	snapshot: PropTypes.object,
	handlePopoverOpen: PropTypes.func.isRequired,
	handlePopoverClose: PropTypes.func.isRequired,
	rowClick: PropTypes.func,
};
